import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from 'src/app/_services/project.service';
import { WorkflowService } from 'src/app/_services/workflow.service';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';

@Component({
  selector: 'app-wf-work',
  templateUrl: './wf-work.component.html',
  styleUrls: ['./wf-work.component.scss']
})
export class WfWorkComponent implements OnInit {
pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  searchString: any;
  taskList: any[] = [];
  filteredData: any;
  filterStatus: any;
  editWorkFlowTaskForm: FormGroup;
  taskDetails: any;
  assigneeTaskDetails: any;
  currentUserDetails: any;
  allUserList: any;
  selectedReassignUser: any;
  reassignTaskForm: any;
  dropdownSettings = {};
  enableReassign: boolean = false;
  isGroupAcceptTask: boolean = false;
  form!: FormGroup;
  selectedFile: File | null = null;
  downloadFileData: any;
  fileData: any;
  fileName: string;

  constructor(
    private projectService: ProjectService,
    private workflowService: WorkflowService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadTaskList();
    this.initAllForms();
  }

  initAllForms() {
  
      this.editWorkFlowTaskForm = this.formBuilder.group({
        comment: ['',]
      });

      this.reassignTaskForm = this.formBuilder.group({
      });

      this.dropdownSettings = {
        singleSelection: true,
        idField: "id",
        textField: "name",
        itemsShowLimit: 5,
        allowSearchFilter: true
      };

      this.form = this.formBuilder.group({
        fields: this.formBuilder.array([])
      });

      this.selectedReassignUser = [];

    }

  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }

  sampleJson = [
      {
        taskName: "Task 1",
        workflowName:'My Amazing Workflow-1',
        description:'test Description DescriptionDescr iptionDescrip tionDescriptionDescriptio nDescription',
        updatedDate:'2025-03-02T225923',
        updatedBy:'Ashutosh',
        dueDate:'2025-03-10T225923',
        status:'Open'
      },
      {
        taskName: "Task 2",
        workflowName:'My Amazing Workflow-2',
        description:'test Description DescriptionDescr iptionDescrip tionDescriptionDescriptio nDescription',
        updatedDate:'2025-03-02T225923',
        dueDate:'2025-03-15T225923',
        updatedBy:'Ashutosh',
        status:'InProgress'
      },
      {
        taskName: "Task 3",
        workflowName:'My Amazing Workflow-3',
        description:'test Description DescriptionDescr iptionDescrip tionDescriptionDescriptio nDescription',
        updatedDate:'17/02/2025',
        dueDate:'2025-03-15T225923',
        updatedBy:'Ashutosh',
        status:'Completed'
      }
    ]

  filterTask()
  {
    if(this.filteredData.length == 0)
    {
      return;
    }
   this.taskList =  this.filteredData.filter(task => {
        let taskName =  task.taskName.toLowerCase();
        let workflowName =  task.workflowName.toLowerCase();
        if(taskName.includes(this.searchString.toLowerCase()) || workflowName.includes(this.searchString.toLowerCase()))
        {
          return true;
        }
    });

  }
  sortColumn: string = 'updatedAt';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortData(column: string) {
    this.sortDirection = this.sortColumn === column && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;
    this.sortDirection === 'asc' ? document.getElementById("sortCol").className = "asc" : document.getElementById("sortCol").className = "desc";
    this.taskList.sort((a, b) => {
      const valueA = a[column as keyof typeof a];
      const valueB = b[column as keyof typeof b];

     if (typeof valueA === 'string' && typeof valueB === 'string') {
       
        return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      if (valueA instanceof Date && valueB instanceof Date) {
       
        return this.sortDirection === 'asc' ? +valueA - +valueB : +valueB - +valueA;
      }

      return 0;
    });
  }

loadTaskList() {

  const currentDate = new Date();

  if(localStorage.getItem("currentUser")) {
    this.currentUserDetails = JSON.parse(localStorage.getItem("currentUser"));
    const currentUserId = this.currentUserDetails["id"];
    var taskDetails = [];

    console.log("currentUserId: ", currentUserId);

    this.workflowService.getAssignedTasks(currentUserId).subscribe(
      (res:any)=>{
      console.log("Tasks Data Response: ", res);
      taskDetails = res || [];

      this.taskList = taskDetails.map(task => {
        if(!task.dueDate || task.dueDate == null) {
          return {
            ...task,
            isOverdue: false
          };
        }
        const taskDate = this.parseDueDate(task.dueDate);
        if(task.status === "Completed") {
          return {
            ...task,
            isOverdue: false
          };
        } else {
          return {
            ...task,
            isOverdue: taskDate < currentDate
          };
        }
      });

      this.filteredData = this.taskList;
      this.sortDirection = 'asc';
      this.searchString = "";
      this.sortData("updatedAt");

      // this.route.fragment.subscribe(fragment => {
      //   if (fragment) {
      //     const params = new URLSearchParams(fragment.split('?')[1]);
      //     const encodedWorkflow = params.get('workflow');
      //     const decodedWorkflow = decodeURIComponent(encodedWorkflow ?? '');
      //     console.log(decodedWorkflow); // Will show spaces correctly
      //   }
      // });

      // ---------------Navigate to Task through email---------------------
      console.log("Row No.: "+window.location.hash);
      const decodedWorkflow = decodeURIComponent(window.location.hash ?? '');
      var params = decodedWorkflow.split("?")[1];
      if(params!=undefined && params!=null && params) {
        var row = params.split("&")[0].split("=")[1];
        var workflow = params.split("&")[1].split("=")[1];
        
        setTimeout(() => {
          this.searchString = workflow;
          this.filterTask();

          setTimeout(() => {
            const el = document.getElementById("row-"+row);
            if(el) {
              el.classList.add('highlight');
              setTimeout(() => el.classList.remove('highlight'), 3000);
            }
          }, 1000);
        }, 2000);
      }
      // ------------------------------------------------------------------

    },(error=>{
      console.log("Error while fetching Assigned Tasks:::::::::::::: ", error);
      this.taskList = []; 
      this.filteredData = [];
    }))
  } else {
    console.log("Current User data not found from local storage.");
  }
}

parseDueDate(dueDate: string): Date {
  // Extract components correctly
  const year = dueDate.substring(0, 4);
  const month = dueDate.substring(5, 7);
  const day = dueDate.substring(8, 10);
  const hours = dueDate.substring(11, 13);
  const minutes = dueDate.substring(13, 15);
  const seconds = dueDate.substring(15, 17);

  // Format it properly
  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

  return new Date(formattedDate);
}

filterData(status: string): void {
  var taskData = this.filteredData;
  this.filterStatus = status;

  if (status === "Overdue") {
    taskData = taskData.filter(item => item.isOverdue);
  } else if (status) {
    taskData = taskData.filter(item => item.status === status);
  } else {
    taskData = [...this.filteredData]; // If no filter, show all
  }
  this.taskList = taskData;
}
 
get fields() {
  return this.form.get('fields') as FormArray;
}

editWorkFlowTask(task: any)
{

  console.log("inside editWorkFlowTask: ", task);
  this.assigneeTaskDetails = task;
  this.isGroupAcceptTask = false;
  this.enableReassign = false;

  this.form = this.formBuilder.group({
    fields: this.formBuilder.array([])
  });

  this.getUserList();

  if(this.assigneeTaskDetails["isGroup"] && this.assigneeTaskDetails["assigneeId"] == null) {
    this.isGroupAcceptTask = true;
  }

  if(this.assigneeTaskDetails.comments) {
    this.editWorkFlowTaskForm.patchValue({
      comment: this.assigneeTaskDetails.comments[this.assigneeTaskDetails.comments.length-1].comment
    });
  }

  if(this.currentUserDetails["id"] === this.assigneeTaskDetails.assigneeId)
    this.assigneeTaskDetails["assignedTo"] = "Me";
  else
    this.assigneeTaskDetails["assignedTo"] = this.assigneeTaskDetails["userName"];

  this.workflowService.getTaskById(task.taskId, this.assigneeTaskDetails["instanceId"]).subscribe((res)=>{
    console.log("Task Details: ", res);
    this.taskDetails = res;
    if(res["form"]) {
      const formData = res["form"]["formFields"];
      formData.forEach((field:any) => {
        const formGroup = this.createFieldGroup(field);
        this.fields.push(formGroup);
      });
    }

    if(this.currentUserDetails?.id !== this.assigneeTaskDetails?.assigneeId) {
      document.getElementById("formSection").className = "formbox";
    } else {
      document.getElementById("formSection").className = "";
    }

  }, error=>{
    console.log("Error while getting task details based on Id: ", error);
  })

}

viewWorkFlowTask(task: any) {
  console.log("inside viewWorkFlowTask: ", task);
  this.assigneeTaskDetails = task;

  this.form = this.formBuilder.group({
    fields: this.formBuilder.array([])
  });

  if(this.assigneeTaskDetails.comments) {
    this.editWorkFlowTaskForm.patchValue({
      comment: this.assigneeTaskDetails.comments[this.assigneeTaskDetails.comments.length-1].comment
    });
  }

  if(this.currentUserDetails["id"] === this.assigneeTaskDetails.assigneeId)
    this.assigneeTaskDetails["assignedTo"] = "Me";
  else
    this.assigneeTaskDetails["assignedTo"] = this.assigneeTaskDetails["userName"];

  this.workflowService.getTaskById(task.taskId, this.assigneeTaskDetails["instanceId"]).subscribe((res)=>{
    console.log("Task Details: ", res);
    this.taskDetails = res;
    if(res["form"]) {
      const formData = res["form"]["formFields"];
      formData.forEach((field:any) => {
        if(field["fieldType"] === "file") {
          this.fileName = field["value"];
          this.workflowService.downloadFile(field["value"]).subscribe(res=>{
            console.log("File Data: ", res);
            this.fileData = res;
            // this.downloadFile();
          }, error => {
            console.log("Error while downloading file: ", error);
            this.toastrService.error("Unable to get the file: "+ this.fileName);
          })
        }
        const formGroup = this.createFieldGroup(field);
        this.fields.push(formGroup);
      });
    }
  }, error=>{
    console.log("Error while getting task details based on Id: ", error);
  })
}

createFieldGroup(field: any): FormGroup {
  switch (field.fieldType) {
    case 'input':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        inputType: [field.inputType],
        required: [field.required],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
    case 'select':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        required: [field.required],
        options: [field.options],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
      });
    case 'date':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        inputType: [field.inputType],
        required: [field.required],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
    case 'file':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        inputType: [field.inputType],
        required: [field.required],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
    case 'checkbox':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        inputType: [field.inputType],
        required: [field.required],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
    case 'text-area':
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        inputType: [field.inputType],
        required: [field.required],
        value: [field.value, field.required ? Validators.required : null],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
    default:
      return this.formBuilder.group({
        label: [field.label],
        fieldType: [field.fieldType],
        required: [field.required],
        value: [field.value],
        validationMessage: [field.validationMessage],
        variableName: [field.variableName]
      });
  }
}

reassignTask(task: any) {
  console.log("Reassign Task: ", task);
  this.enableReassign = true;
}

saveReassignTask(task: any, isAccept: any) {
  console.log("Reassigning task...");
  console.log("Assign Task to: ", task);
  if(this.assigneeTaskDetails.isGroup && this.isGroupAcceptTask) {
    this.assigneeTaskDetails["assigneeId"] = this.currentUserDetails["id"];
    this.assigneeTaskDetails["userName"] = this.currentUserDetails["name"];
  } else {
    this.assigneeTaskDetails["previousAssigneeId"] = this.assigneeTaskDetails["assigneeId"];
    this.assigneeTaskDetails["previousAssigneeName"] = this.assigneeTaskDetails["userName"];
    this.assigneeTaskDetails["assigneeId"] = task["id"];
    this.assigneeTaskDetails["userName"] = task["name"];
  }
  console.log("selectedReassignUser: ", this.selectedReassignUser);
  this.workflowService.createAssigneeTask(this.assigneeTaskDetails, isAccept).subscribe(res=>{
    if(isAccept == true) {
      console.log("Task Accepted Successfully!");
      this.toastrService.success("Task Accepted Successfully!");
    } else {
      console.log("Task Reassigned Successfully!");
      this.toastrService.success("Task Reassigned Successfully!");
    }
    this.selectedReassignUser = [];
    this.loadTaskList();
  }, error=>{
    if(isAccept == true) {
      console.log("Unable to Accept Task: ", error);
      this.toastrService.success("Unable to Accept Task: ", error);
    } else {
      console.log("Unable to Reassign Task: ", error);
      this.toastrService.success("Unable to Reassign Task: ", error);
    }
  });
}

getUserList() {
  
  this.workflowService.getAllActiveCustomers().subscribe(res=>{
    console.log("Company User List: ", res);
    this.allUserList = res;
    this.allUserList = this.allUserList.filter(user=>{
      return user["id"] != this.currentUserDetails["id"];
    })

    if(this.assigneeTaskDetails.isGroup && this.assigneeTaskDetails["associatedTo"]) {
      this.workflowService.getWorkFlowGroup(this.assigneeTaskDetails["associatedTo"]).subscribe(res=>{
        console.log("Get all users of a group: ", res);
        var groupUserIds = res["userIds"];
        this.allUserList = this.allUserList.filter(user=>{
          return groupUserIds.includes(user["id"]);
        })
      }, error => {
        console.log("Error while getting all users of a group: ", error);
      });
    }

  }, error => {
    console.log("Error while getting company user list: ", error);
  });
}

onItemSelect(item: any) {
  console.log(item);
}

onSelectAll(items: any) {
  console.log(items);
}

public onDeSelect(item: any) {  
  console.log(item);
}

onFileSelect(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    this.selectedFile = input.files[0];
    console.log('Selected File:', this.selectedFile);
  }
}

uploadFile(formData: any) {
  // Allowed file extensions
  const allowedExtensions = ['pdf', 'docx', 'xls', 'doc', 'txt'];
  // Extract file extension
  const fileExtension = this.selectedFile.name.split('.').pop()?.toLowerCase();
  if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
    this.toastrService.error('Only PDF, DOCX, XLS, DOC, and TXT files are allowed.');
    return;
  }

  this.workflowService.uploadFile(formData).subscribe(
    (response) => {
      console.log('File uploaded successfully', response);
      this.toastrService.success('File uploaded successfully!');
    },
    (error) => {
      console.error('File upload failed', error);
      this.toastrService.error('File upload failed.');
    });
}

downloadFile() {
  // if (!this.selectedFile) {
  //   alert("No file selected!");
  //   return;
  // }

  // Read the file from FormData
  // const file = this.downloadFileData.get('file') as File;
  // const blob = new Blob([file], { type: file.type });
  const blob = this.fileData;
  const url = window.URL.createObjectURL(blob);

  // Create a temporary link & trigger download
  const a = document.createElement('a');
  a.href = url;
  a.download = this.fileName;
  document.body.appendChild(a);
  a.click();
  
  // Cleanup
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

saveTask(status: any) {
  if(status === "submit") {
    console.log("inside submit the form.");
    this.taskDetails["status"] = "Completed";
  }
  else {
    console.log("inside save the form as draft.");
    this.taskDetails["status"] = "InProgress";
  }

  const formData = new FormData();
  formData.append('file', this.selectedFile);
  console.log("Uploading File: ", formData);
  
  if(this.selectedFile) {
    this.uploadFile(formData);
    if(this.form.value && this.form.value['fields']) {
      this.form.value['fields'].forEach(element=>{
        if(element["fieldType"] === "file") {
          element["value"] = this.selectedFile["name"];
        }
      });
    }
  }

  console.log('Form Data:', this.form.value);
  if(this.taskDetails["form"] && this.taskDetails["form"]["formFields"])
    this.taskDetails["form"]["formFields"] = this.form.value['fields'];

  // if(this.assigneeTaskDetails.comments && this.editWorkFlowTaskForm.value.comment != this.assigneeTaskDetails.comments.comment) {
    var commentData = {
      userId: this.currentUserDetails["id"],
      comment: this.editWorkFlowTaskForm.value.comment,
      dateTime: new Date().toString()
    }
    if(!this.assigneeTaskDetails.comments) {
      this.assigneeTaskDetails.comments = [commentData];
    } else {
      this.assigneeTaskDetails.comments.push(commentData);
    }
  // }

  const taskRequest = {
    "comments" : this.assigneeTaskDetails.comments,
    "task" : this.taskDetails,
    "assigneeTaskId" : this.assigneeTaskDetails.assigneeTaskId
  }

  this.workflowService.saveTask(taskRequest).subscribe(res=>{
    if(status === "submit") {
      console.log("Task submitted successfully.");
      this.toastrService.success("Task submitted successfully.");
    }
    else {
      console.log("Task saved as draft successfully.");
      this.toastrService.info("Task saved as draft successfully.");
    }
    this.loadTaskList();
  }, error=>{
    if(status === "submit") {
      console.log("Unable to submit task: ", error);
      this.toastrService.error("Unable to submit task: ", error);
    }
    else {
      console.log("Unable to save task as draft: ", error);
      this.toastrService.error("Unable to save task as draft: ", error);
    }
  });
}

onCheckboxChange(event: Event, field: FormGroup) {
  const isChecked = (event.target as HTMLInputElement).checked;
  field.get('value')?.setValue(isChecked ? true : null);
}

}
